import type ImageType from "@travily/types/shared/Image";
import { ResolvedImage } from "@ui/components/internal/ResolvedImage";
import { tv } from "@ui/lib/tv";

const coverImage = tv({
  slots: {
    root: "relative w-full overflow-hidden md:rounded-3xl",
    image: "block h-[200px] w-full object-cover md:h-[300px] lg:h-[424px]",
    gradient:
      "pointer-events-none absolute inset-x-0 bottom-0 hidden h-[104px] bg-gradient-to-b from-white/0 to-black/10 md:block",
  },
});

export interface CoverImageProps {
  /** Structured image (new path — uses `<Image>` with srcset, blurhash, lazy loading). */
  image?: ImageType | null;
  /** Legacy string URL. Prefer `image`. */
  src?: string;
  /** Legacy alt text. Ignored when `image` is passed — alt comes from `image.alt`. */
  alt?: string;
  className?: string;
  priority?: boolean;
}

export function CoverImage({ image, src, alt, className, priority }: CoverImageProps) {
  const styles = coverImage();

  return (
    <div className={styles.root({ className })}>
      <ResolvedImage
        image={image}
        src={src}
        // Structured images carry their own alt — the legacy prop only names the bare `<img>`.
        alt={image ? undefined : alt}
        priority={priority}
        sizes="(min-width: 1440px) 1376px, (min-width: 768px) calc(100vw - 64px), 100vw"
        className={styles.image()}
      />
      <div aria-hidden="true" className={styles.gradient()} />
    </div>
  );
}
